import React, { useState, useEffect } from "react";

// css
import "assets/style/elements/color-menu-list.scss";

// elements
import ColorLabel from "components/elements/ColorLabel"

function Element({ text, className }) {
  return (
    <>
      <ul className={"color-menu-list " + className}>
        <li>
          <div className="text-area">
            <span>1</span>
            <ColorLabel color="yellow" className="ml8" />
            <span className="ml8 text-ellipsis-1">계란볶음밥</span>
          </div>
          <p className="count-member">30명</p>
        </li>

        <li>
          <div className="text-area">
            <span>2</span>
            <ColorLabel color="green" className="ml8" />
            <span className="ml8 text-ellipsis-1">미역국</span>
          </div>
          <p className="count-member">30명</p>
        </li>
        <li>
          <div className="text-area">
            <span>3</span>
            <ColorLabel color="brown" className="ml8" />
            <span className="ml8 text-ellipsis-1">땅콩볶음</span>
          </div>
          <p className="count-member">30명</p>
        </li>
        <li>
          <div className="text-area">
            <span>4</span>
            <ColorLabel color="red" className="ml8" />
            <span className="ml8 text-ellipsis-1">사과주스</span>
          </div>
          <p className="count-member">30명</p>
        </li>
      </ul>
    </>
  );
}

export default Element;
